import React from 'react';
import { createRoot } from 'react-dom/client';
import { tracer } from './services/telemetry/otel';
import { App } from './App';
import './assets/styles.css';
import posthog from 'posthog-js';
import { PostHogProvider } from '@posthog/react';

const { VITE_POSTHOG_API_KEY, VITE_POSTHOG_HOST, MODE } = import.meta.env;

if (typeof window !== 'undefined') {
  tracer();
}

if (VITE_POSTHOG_API_KEY && VITE_POSTHOG_HOST) {
  posthog.init(VITE_POSTHOG_API_KEY, {
    api_host: VITE_POSTHOG_HOST,
    person_profiles: 'identified_only',
    capture_pageview: false,
    loaded: (posthogInstance) => {
      posthogInstance.onFeatureFlags(() => {
        posthogInstance.capture('$pageview');
      });
    },
    persistence: 'localStorage',
  });
} else {
  if (MODE !== 'production') {
    console.warn('PostHog API key or host is not defined. PostHog will not be initialized.');
  }
}

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

createRoot(container).render(
  <React.StrictMode>
    {VITE_POSTHOG_API_KEY && VITE_POSTHOG_HOST ? (
      <PostHogProvider client={posthog}>
        <App />
      </PostHogProvider>
    ) : (
      <App />
    )}
  </React.StrictMode>,
);
